module.exports = __webpack_public_path__ + "img/indu_active_9.31e8c9b2.png";